export default {
  bookingSummaryHeader: '05012017-162912-4428',
  freeWithYourIncludedVisit: '29092022-163625-0006',
  discount: '19122018-152801-0040',
  orderDetails: '23122019-153433-0006',
  date: '27042016-120243-3939',
  time: '22112016-144753-8440',
  numberOfPeople: '19122018-152801-0002',
};
